import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events')({
  component: EventsLayout,
});

function EventsLayout() {
  return <Outlet />;
}

